









































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import firebase from 'firebase'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import EventBus from '../event-bus'
import { UserType } from '../types'
import { UserTypeCollection } from '../helpers/collections'
import CardList from '../components/layout/CardList.vue'
import 'vue-croppa/dist/vue-croppa.css'

const Croppa = require('vue-croppa')

Vue.component('croppa', Croppa.component)

@Component({
  components: {
    CardList,
  },
})
export default class Settings extends Mixins(MainMixin) {
  // tabs = [{ title: 'View', value: 'view' }, { title: 'New Board', value: 'new' }, { title: 'Edit Board', value: 'edit' }]
  phone = ''

  profile: any = {}

  test: any = null

  loadingpw = false

  showImageUpdate = false

  showUpdatePassword = false

  get firstLogin () {
    return this.$store.state.user.auth.phone === ''
  }

  get imageLoaded () {
    if (!this.profile.hasImage) return false
    return this.profile.hasImage()
  }

  get canUpdate () {
    if (!this.imageLoaded && this.showImageUpdate) return false
    if (this.showUpdatePassword) return false
    if (this.firstLogin) {
      if (this.phone.length !== 14) return false
    } if (!this.firstLogin) {
      if (this.phone === this.prettyPhone(this.$store.state.user.auth.phone) && !this.showImageUpdate) return false
    } return true
  }

  loading = false

  newPassword = ''

  testPw = ''

  created () {
    if (!this.firstLogin) {
      this.phone = this.prettyPhone(this.$store.state.user.auth.phone) || ''
    }
  }

  isValidPassword (x: string) {
    const validTest = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
    return validTest.test(x)
  }

  oldPassword = ''

  async reauthenticate () {
    try {
      const user = firebase.auth().currentUser
      const credential = firebase.auth.EmailAuthProvider.credential(this.$store.state.user.auth.email, this.oldPassword)
      if (!user) return false
      console.log('cred: ', credential)
      const result = await user.reauthenticateWithCredential(credential)
      console.log('result: ', result)
      this.showUpdatePassword = false
      this.oldPassword = ''
      this.$toast.success('Successfully Reauthenticated')
      return this.updatePassword()
    } catch (e) {
      console.log(e)
      this.showUpdatePassword = false
      this.oldPassword = ''
      this.$toast.error('Error Reauthenticating - Please Check Your Password')
      return false
    }
  }

  async updatePassword () {
    const user = firebase.auth().currentUser
    if (!user || !this.isValidPassword(this.newPassword) || this.newPassword !== this.testPw) return false
    this.loadingpw = true
    try {
      const result: any = await user.updatePassword(this.newPassword)
      console.log('result is: ', result.code)
    } catch (e) {
      if (e.code === 'auth/requires-recent-login') {
        console.log('here:::', e)
        this.showReloginForm = true
        return false
      }
    }
    this.$toast.success('Successfully Changed Password')
    this.loadingpw = false
    this.showUpdatePassword = false
    this.newPassword = ''
    this.testPw = ''
    this.oldPassword = ''
    return true
  }

  showReloginForm = false

  async submit () {
    console.log('pr: ', this.profile)
    this.loading = true
    if (this.firstLogin && !this.profile.hasImage()) {
      this.loading = false
      return this.$toast.error('Please Upload Image')
    }
    try {
      if (this.firstLogin || this.showImageUpdate) {
        const blob = await this.profile.promisedBlob()
        const fileType = blob.type.split('/')[1]
        const result = await firebase.app().storage('canvas-forms-profiles').ref(`/profiles/${this.$store.getters.uid}.${fileType}`).put(blob)
      }
      console.log('phone here1 is: ', this.phone)
      const phone = this.dbPhone(this.phone)
      console.log('phone here is: ', phone)
      const userResult = await update(UserTypeCollection, this.$store.getters.uid, {
        phone,
      })
      console.log('userresult: ', userResult)
      this.loading = false
      this.$toast.success('Profile Updated')
      return this.$router.push(this.firstLogin ? '/location' : '/welcome')
    } catch (e) {
      console.log('error: ', e)
      this.loading = false
      return this.$toast.error('Error Updating User')
    }
  }
}
